import { useQuery } from "@tanstack/react-query";
import { TanstackQueryKey } from "apps/commons/tanstackQueryKey";
import { oneOnboardingApi } from "libs/api";
import { isOnboardingRouteValid, toOnboardingApiIdentity } from "../routes/onboardingRouteApi";
import { useOnboardingRouteId } from "../useOnboardingRouteId";
import { useSetPostPublishViewModel } from "./postPublishViewModelAtom";

export const useGetPostPublishViewModel = () => {
    const setViewModel = useSetPostPublishViewModel();
    const route = useOnboardingRouteId();
    const apiIdentity = toOnboardingApiIdentity(route);

    const queryResult = useQuery({
        queryKey: [TanstackQueryKey.GetPropertyViewModel, "postPublish", route.lang, route.id],
        queryFn: () =>
            oneOnboardingApi.getPostPublishViewModel(route.lang, apiIdentity.onboardingId, apiIdentity.propertyId),
        enabled: isOnboardingRouteValid(route),
        onSuccess: (response) => setViewModel(response.data),
    });

    return {
        isLoading: queryResult.isLoading,
        isSuccess: queryResult.isSuccess,
        isError: queryResult.isError,
        data: queryResult.data,
    };
};
